import { render, staticRenderFns } from "./MyProfilePage.vue?vue&type=template&id=09882d00&scoped=true&"
import script from "./MyProfilePage.vue?vue&type=script&lang=js&"
export * from "./MyProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./MyProfilePage.vue?vue&type=style&index=0&id=09882d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09882d00",
  null
  
)

export default component.exports